import { render, staticRenderFns } from "./video-play.vue?vue&type=template&id=c11d75ee&scoped=true"
import script from "./video-play.vue?vue&type=script&lang=js"
export * from "./video-play.vue?vue&type=script&lang=js"
import style0 from "./video-play.vue?vue&type=style&index=0&id=c11d75ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11d75ee",
  null
  
)

export default component.exports